

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const EVENTGETALL= createAsyncThunk(
  "EventGetAll/EventGetAll",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const EventGetAllSlice = createSlice({
  name: "EventGetAllSlice",
  initialState: {
    EventGetAll: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfEventGetAll: (state) => {
        state.EventGetAll.loading = false
        state.EventGetAll.error = false
        state.EventGetAll.data = []
        state.EventGetAll.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(EVENTGETALL.fulfilled, (state, action) => {
      state.EventGetAll = {
        ...state.EventGetAll,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(EVENTGETALL.pending, (state, action) => {
      state.EventGetAll = {
        ...state.EventGetAll,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(EVENTGETALL.rejected, (state, action) => {
      state.EventGetAll = {
        ...state.EventGetAll,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const EventGetAllAction = {
    EVENTGETALL,
};

export { EventGetAllAction };
export default EventGetAllSlice.reducer;
export const {setInitialStateOfEventGetAll} = EventGetAllSlice.actions
